import { LocationPortableSettingsComponent } from './admin-portal/location-portable-settings/location-portable-settings.component';
import { GoogleAccountsService } from './providers/google-accounts.service';
import { SelectLocationDropdownComponent } from './components/select-location-dropdown/select-location-dropdown.component';
import { BrightLocalService } from './providers/bright-local.service';
import { FacilityReviewsComponent } from './admin-portal/facility-reviews/facility-reviews.component';
import { AngularFilemanagerDirective } from './directives/angular-filemanager';
import { StorageTipsComponent } from './components/storage-tips/storage-tips.component';
import { FaqComponent } from './components/faqs/faqs.component';
import { AWSConnectorService } from './providers/aws-connector';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import 'hammerjs';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule, Routes } from "@angular/router";
import { PortalHomeComponent } from './admin-portal/portal-home/portal-home.component';
import { LoginComponent } from './admin-portal/login/login.component';
import { AngularFireModule } from "angularfire2";
import { environment } from '../environments/environment';
import { AngularFireDatabaseModule } from "angularfire2/database-deprecated";
import { AngularFireAuthModule } from "angularfire2/auth";
import { FirebaseService } from "./providers/firebase.service";
import { FormsModule } from "@angular/forms";
import {
  MdButtonToggleModule, MdCardModule, MdCheckboxModule, MdChipsModule, MdInputModule,
  MdMenuModule, MdSlideToggleModule, MdSnackBarModule, MdDialogModule,
  MdToolbarModule, MdProgressSpinnerModule, MdSelectModule, MdTableModule
} from "@angular/material";
import { NavbarComponent } from "./components/navbar/navbar.component";
import {
  AutoCompleteModule, ChipsModule,
  DataTableModule, DialogModule, DropdownModule, EditorModule, InputMaskModule, InputTextareaModule, InputTextModule,
  MultiSelectModule, SharedModule,
  SpinnerModule
} from "primeng/primeng";
import { ViewClientComponent } from './admin-portal/view-client/view-client.component';
import { ViewLocationComponent } from './admin-portal/view-location/view-location.component';
import { EmailSettingsComponent } from './admin-portal/email-settings/email-settings.component';
import { ComponentDataSettingsComponent } from './admin-portal/component-data-settings/component-data-settings.component';
import { PageSettingsComponent } from './admin-portal/page-settings/page-settings.component';
import { NavigationItemComponent } from './components/navigation-item/navigation-item.component';
import { OfficeHoursComponent } from './components/office-hours/office-hours.component';
import { GateHoursComponent } from './components/gate-hours/gate-hours.component';
import { SizeGuideSizesComponent } from './components/size-guide-sizes/size-guide-sizes.component';
import { SiteAdminEmailsComponent } from './components/site-admin-emails/site-admin-emails.component';
import { UpdateCacheService } from "./providers/update-cache.service";
import { HttpModule } from "@angular/http";
import { FormsRetrieveSettingsComponent } from './admin-portal/forms-retrieve-settings/forms-retrieve-settings.component';
import { FormsService } from "./providers/forms.service";
import { MobileAppSettingsComponent } from './admin-portal/mobile-app-settings/mobile-app-settings.component';
import { ComponentStructureSettingsComponent } from './admin-portal/component-structure-settings/component-structure-settings.component';
import { LoadingServiceProvider } from "./providers/loading-service";
import { LoadingDialogComponent } from "./components/loading-dialog/loading-dialog.component";
import { ComponentStructureComponent } from './components/component-structure/component-structure.component';
import { ComponentStructureSettingsOnlyComponent } from './components/component-structure-settings-only/component-structure-settings-only.component';
import { MapsService } from './providers/maps.service';
import { ScrollService } from "./providers/scroll.service";
import { CacheMiddlewareService } from "./providers/cache-middleware.service";
import { ShortUrlService } from "./providers/short-url.service";
import { ShortUrlGraphComponent } from './admin-portal/short-url-graph/short-url-graph.component';
import { ChartsModule } from "ng2-charts";
import { PugglStatsComponent } from './admin-portal/puggl-stats/puggl-stats.component';
import { EmailTrackerComponent } from './admin-portal/email-tracker/email-tracker.component';
import { EmailTrackerService } from "./providers/email-tracker.service";
import { FroalaEditorModule, FroalaViewModule } from "angular-froala-wysiwyg";
import { FormsRetrieveSettingVariablesComponent } from './admin-portal/forms-retrieve-setting-variables/forms-retrieve-setting-variables.component';
import { SignaturePadModule } from "angular2-signaturepad";
import { TabsModule, AccordionModule } from "ngx-bootstrap";
import { LocationComponentDataSettingsComponent } from './admin-portal/location-component-data-settings/location-component-data-settings.component';
import { FormsCreateLeasesComponent } from './admin-portal/forms-create-leases/forms-create-leases.component';
import { NgDragDropModule } from "ng-drag-drop";
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { FileUploadModule } from "primeng/fileupload";
import { ComponentThemesComponent } from './admin-portal/component-themes/component-themes.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { ComponentFileUploadComponent } from './admin-portal/component-file-upload/component-file-upload.component';
import { DataGridModule } from "primeng/datagrid";
import { PanelModule } from "primeng/panel";
import { HttpClientModule } from "@angular/common/http";
import { TreeModule } from 'primeng/tree';
import { OverlayPanelModule } from "primeng/overlaypanel";
import { InplaceModule } from "primeng/inplace";
import { MenubarModule } from "primeng/menubar";
import { UpgradeModule, downgradeComponent } from '@angular/upgrade/static';
import { StepsModule } from 'primeng/steps';
import { LaddaModule } from 'angular2-ladda';
import { LocationSizeGuideComponent } from './admin-portal/location-size-guide/location-size-guide.component';
import { CustomPagesComponent } from './admin-portal/custom-pages/custom-pages.component';
import { EditCustomPageComponent } from './admin-portal/edit-custom-page/edit-custom-page.component';
import { DragulaModule } from 'ng2-dragula';
import { NewSizeGuideSizesComponent } from './components/new-size-guide-sizes/new-size-guide-sizes.component';
import { SizeGuideComponent } from './admin-portal/size-guide/size-guide.component';
import { PortableSettingsComponent } from './admin-portal/portable-settings/portable-settings.component';
import { IntegrationsComponent } from './admin-portal/integrations/integrations.component';
import { BlogSettingsComponent } from './admin-portal/blog-settings/blog-settings.component';
import { OnboardingLocationViewComponent } from './components/onboarding-location-view/onboarding-location-view.component';
import { LocationCheckoutChargesComponent } from './admin-portal/location-checkout-charges/location-checkout-charges.component';
import { EscapeHtmlPipe } from './pipes/keep-html.pipe';
import { SeoComponent } from './admin-portal/seo/seo.component';
import { LocationsDataComponent } from './admin-portal/locations-data/locations-data.component';
import { SlideshowComponent } from './components/slideshow/slideshow.component';
import { HowToRowComponent } from './components/howto-row/howto-row.component';
import { PictureCardComponent } from './components/picture-card/picture-card.component';
import { TableService } from './providers/table-service.service';
import { GeneralConnectorService } from './providers/general-connector.service';
import { AuthGuard } from './providers/auth.guard';

const routes: Routes = [
  { path: '', component: PortalHomeComponent, canActivate: [AuthGuard] },
  { path: 'clients/:key', component: ViewClientComponent, canActivate: [AuthGuard] },
  { path: 'short-url-graph', component: ShortUrlGraphComponent, canActivate: [AuthGuard] },
  { path: 'puggl-stats', component: PugglStatsComponent, canActivate: [AuthGuard] },
  { path: 'files', component: ComponentFileUploadComponent, canActivate: [AuthGuard] },
  { path: 'email-tracker-stats', component: EmailTrackerComponent, canActivate: [AuthGuard] },
  { path: 'clients/:key/settings/component-data', component: ComponentDataSettingsComponent, canActivate: [AuthGuard] },
  { path: 'clients/:key/settings/reviews', component: FacilityReviewsComponent, canActivate: [AuthGuard] },
  { path: 'clients/:key/settings/component-structure', component: ComponentStructureSettingsComponent, canActivate: [AuthGuard] },
  { path: 'clients/:key/settings/component-structure/themes', component: ComponentThemesComponent, canActivate: [AuthGuard] },
  { path: 'clients/:key/settings/email', component: EmailSettingsComponent, canActivate: [AuthGuard] },
  { path: 'clients/:key/settings/size-guide', component: SizeGuideComponent, canActivate: [AuthGuard] },
  { path: 'clients/:key/settings/integrations', component: IntegrationsComponent, canActivate: [AuthGuard] },
  { path: 'clients/:key/settings/seo', component: SeoComponent, canActivate: [AuthGuard] },
  { path: 'clients/:key/settings/locations-data', component: LocationsDataComponent, canActivate: [AuthGuard] },
  { path: 'clients/:key/settings/page', component: PageSettingsComponent, canActivate: [AuthGuard] },
  { path: 'clients/:key/settings/custom-pages', component: CustomPagesComponent, canActivate: [AuthGuard] },
  { path: 'clients/:key/settings/blog', component: BlogSettingsComponent, canActivate: [AuthGuard] },
  { path: 'clients/:key/settings/portable-settings', component: PortableSettingsComponent, canActivate: [AuthGuard] },
  { path: 'clients/:key/settings/custom-pages/:pageKey', component: EditCustomPageComponent, canActivate: [AuthGuard] },
  { path: 'clients/:key/location', component: ViewLocationComponent, canActivate: [AuthGuard] },
  { path: 'clients/:key/location/:locKey', component: ViewLocationComponent, canActivate: [AuthGuard] },
  { path: 'clients/:key/location/:locKey/settings/mobile', component: MobileAppSettingsComponent, canActivate: [AuthGuard] },
  { path: 'clients/:key/location/:locKey/settings/component', component: LocationComponentDataSettingsComponent, canActivate: [AuthGuard] },
  { path: 'clients/:key/location/:locKey/settings/size-guide', component: LocationSizeGuideComponent, canActivate: [AuthGuard] },
  { path: 'clients/:key/location/:locKey/settings/portable-settings', component: LocationPortableSettingsComponent, canActivate: [AuthGuard] },
  { path: 'clients/:key/location/:locKey/settings/checkout-settings', component: LocationCheckoutChargesComponent, canActivate: [AuthGuard] },
  { path: 'clients/:key/location/:locKey/settings/create-leases', component: FormsCreateLeasesComponent, canActivate: [AuthGuard] },
  { path: 'clients/:key/location/:locKey/settings/forms', component: FormsRetrieveSettingsComponent, canActivate: [AuthGuard] },
  { path: 'clients/:key/location/:locKey/settings/forms/variables', component: FormsRetrieveSettingVariablesComponent, canActivate: [AuthGuard] },
  { path: 'clients/:key/location/:locKey/settings/forms/:formKey', component: FormsRetrieveSettingsComponent, canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent }
];

@NgModule({
  declarations: [
    AppComponent,
    PortalHomeComponent,
    LoginComponent,
    NavbarComponent,
    ViewClientComponent,
    ViewLocationComponent,
    EmailSettingsComponent,
    ComponentDataSettingsComponent,
    PageSettingsComponent,
    CustomPagesComponent,
    EditCustomPageComponent,
    NavigationItemComponent,
    OfficeHoursComponent,
    GateHoursComponent,
    SizeGuideSizesComponent,
    SiteAdminEmailsComponent,
    FormsRetrieveSettingsComponent,
    MobileAppSettingsComponent,
    ComponentStructureSettingsComponent,
    LoadingDialogComponent,
    ComponentStructureComponent,
    ComponentStructureSettingsOnlyComponent,
    ShortUrlGraphComponent,
    PugglStatsComponent,
    EmailTrackerComponent,
    FormsRetrieveSettingVariablesComponent,
    LocationCheckoutChargesComponent,
    LocationComponentDataSettingsComponent,
    FormsCreateLeasesComponent,
    ComponentThemesComponent,
    FileUploadComponent,
    ComponentFileUploadComponent,
    AngularFilemanagerDirective,
    FaqComponent,
    StorageTipsComponent,
    FacilityReviewsComponent,
    LocationSizeGuideComponent,
    NewSizeGuideSizesComponent,
    SizeGuideComponent,
    SelectLocationDropdownComponent,
    PortableSettingsComponent,
    LocationPortableSettingsComponent,
    IntegrationsComponent,
    BlogSettingsComponent,
    OnboardingLocationViewComponent,
    EscapeHtmlPipe,
    SeoComponent,
    LocationsDataComponent,
    SlideshowComponent,
    HowToRowComponent,
    PictureCardComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(routes),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    FormsModule,
    // MaterialModule,
    TabsModule.forRoot(),
    NgDragDropModule.forRoot(),
    BsDropdownModule.forRoot(),
    ButtonsModule.forRoot(),
    AccordionModule.forRoot(),
    MdToolbarModule,
    MdCheckboxModule,
    MdButtonToggleModule,
    MdSlideToggleModule,
    MdCardModule,
    MdMenuModule,
    MdInputModule,
    MdChipsModule,
    MdSnackBarModule,
    MdSelectModule,
    MdTableModule,
    MdDialogModule,
    MdProgressSpinnerModule,
    SharedModule,
    ChipsModule,
    DataTableModule,
    InputTextModule,
    DialogModule,
    DropdownModule,
    SpinnerModule,
    AutoCompleteModule,
    InputMaskModule,
    InputTextareaModule,
    HttpModule,
    HttpClientModule,
    EditorModule,
    MultiSelectModule,
    ChartsModule,
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    SignaturePadModule,
    FileUploadModule,
    DataGridModule,
    PanelModule,
    TreeModule,
    OverlayPanelModule,
    InplaceModule,
    MenubarModule,
    UpgradeModule,
    StepsModule,
    LaddaModule,
    DragulaModule,
  ],
  providers: [
    {
      provide: '$scope',
      useFactory: i => i.get('$rootScope'),
      deps: ['$injector']
    },
    FirebaseService,
    AuthGuard,
    UpdateCacheService,
    FormsService,
    LoadingServiceProvider,
    ScrollService,
    MapsService,
    CacheMiddlewareService,
    ShortUrlService,
    EmailTrackerService,
    AWSConnectorService,
    BrightLocalService,
    GoogleAccountsService,
    TableService,
    GeneralConnectorService
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    LoadingDialogComponent
  ]
})
export class AppModule {
  constructor(
    private upgrade: UpgradeModule
  ) {
    this.upgrade.bootstrap(document.body, ['FileManagerApp']);
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/app.module.ts